import { __exports as MSI1110 } from "./index213.js";
import { __require as requireMSI } from "./index175.js";
import { __require as requireChecksums } from "./index210.js";
var hasRequiredMSI1110;
function requireMSI1110() {
  if (hasRequiredMSI1110) return MSI1110;
  hasRequiredMSI1110 = 1;
  Object.defineProperty(MSI1110, "__esModule", {
    value: true
  });
  var _MSI2 = requireMSI();
  var _MSI3 = _interopRequireDefault(_MSI2);
  var _checksums = requireChecksums();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var MSI1110$1 = (function(_MSI) {
    _inherits(MSI11102, _MSI);
    function MSI11102(data, options) {
      _classCallCheck(this, MSI11102);
      data += (0, _checksums.mod11)(data);
      data += (0, _checksums.mod10)(data);
      return _possibleConstructorReturn(this, (MSI11102.__proto__ || Object.getPrototypeOf(MSI11102)).call(this, data, options));
    }
    return MSI11102;
  })(_MSI3.default);
  MSI1110.default = MSI1110$1;
  return MSI1110;
}
export {
  requireMSI1110 as __require
};
//# sourceMappingURL=index179.js.map
